import React from 'react';
import notificationsService from '@classes/notifications_service';
import Notification from './notification';

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
    };
  }

  componentDidMount() {
    this.notificationsSubscription = notificationsService.subscribe((notifications) => {
      this.setState({
        notifications,
      });
    });
  }

  componentWillUnmount() {
    this.notificationsSubscription.unsubscribe();
  }

  render() {
    return (
      <ul className="notifications" data-purpose="notifications">
        {this.state.notifications.map((notification) => (
          <Notification key={notification.id} {...{ ...notification }} />
        ))}
      </ul>
    );
  }
}

export default Notifications;
